import Vue from 'vue'

// import 'node_modules/bootstrap/dist/js/bootstrap.js'
import './assets/css/animate.css' // inputa os icones
import './assets/scss/all.scss'

import './config/fontawesome'

import ModalExcluir from './components/modal-excluir'
Vue.use(ModalExcluir)

import ModalCancelar from './components/modal-cancelar'
Vue.use(ModalCancelar)

import Notify from './components/notify/index'
Vue.use(Notify);

import Msg from './components/notify/msg/index'
Vue.use(Msg);

import VueMask from 'di-vue-mask'
Vue.use(VueMask);

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import routers from './routers/rules'

import VeeValidate from 'vee-validate'
import config from './config/vee-validate'
Vue.use(VeeValidate, config);

import globalMix from './mixins/global'
Vue.mixin(globalMix)

import components from './config/components'
Object.keys(components).forEach(key => Vue.component(key, components[key]))

import filters from './filters/main'
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

import directives from './directives/main'
Object.keys(directives).forEach(key => Vue.directive(key, directives[key]))

import store from './store/store'
import storage from './config/local-storage'

import { mapActions, mapState } from 'vuex'


import { LMap, LTileLayer, LMarker, LCircle, LPopup, LTooltip, LControlLayers, LLayerGroup, LPolyline, LWMSTileLayer } from 'vue2-leaflet';
import { Icon } from "leaflet";
import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/leaflet.js';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
 iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
 iconUrl: require("leaflet/dist/images/marker-icon.png"),
 shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-circle', LCircle);
Vue.component('l-popup', LPopup)
Vue.component('l-tooltip', LTooltip) 
Vue.component('l-control-layers', LControlLayers)
Vue.component('l-layer-group', LLayerGroup)
Vue.component('l-polyline', LPolyline)
Vue.component('l-wms-tile-layer', LWMSTileLayer )

import 'regenerator-runtime/runtime'


global.$vue = new Vue({
	el: '#app',
	router: routers,
	store,
	render: h => h('router-view'),
	computed: {
		...mapState({
			sessao: state => state.sessao.user,
			websocket: state => state.sessao.webSocket,
			config: state => state.sessao.config,
			baseURL: state => state.sessao.baseURL,
		}),
	},
	beforeMount() {

		// se não tiver a base URL carregada
		if(this.baseURL == null){
			if(sessionStorage.getItem(storage.localBaseURL) != null){
				let base = JSON.parse(sessionStorage.getItem(storage.localBaseURL))
				this.setBaseURL(base)
			}
		}


		// config do sistema
		if(this.config == null){
			if(sessionStorage.getItem(storage.localConfig) != null){
				let config = JSON.parse(sessionStorage.getItem(storage.localConfig))
				this.setConfig(config)
			}
		}

		if(this.sessao == null){
			// se existir config do cliente
			if(sessionStorage.getItem(storage.localSession) != null){

				let token = JSON.parse(sessionStorage.getItem(storage.localSession)).token
				this.setSession(token)
			}
		}
		
		// se não existir conexao
		if(!this.websocket && this.sessao != null){
			this._webSoketConnect()
		}
	},

	methods: {
		...mapActions(['setSession','setBaseURL', 'setConfig']),
	}
})

Vue.prototype.$filters = Vue.options.filters






// WEBPACK FOOTER //
// ./src/main.js